import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_09_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-09-01",
    "name": "跪姿俯卧撑",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["跪姿降低难度", "胸部主导发力"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/2ef130bdc8616ebeafbd2171.mp4",
    "videoUrl": "/media/collections-20261008/videos/35cf0a3ab26b6638f1c11bda.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第9期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-09-02",
    "name": "上斜卧推",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "upper-chest",
    "tips": ["按教学使用史密斯完成上斜卧推", "控制下降和推起节奏"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-6c5278007e11aa838c0c080d.mp4",
    "videoUrl": "/media/collections-20261008/videos/ff521a621c2e6dbcf6e77134.mp4",
    "targetMuscles": ["胸大肌上部", "三角肌前束", "肱三头肌"],
    "difficulty": "intermediate",
    "source": "焚诀计划 · 第9期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-09-03",
    "name": "龙门架夹胸",
    "bodyPart": "chest",
    "equipment": "cable",
    "subCategory": "inner-chest",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌中缝", "前锯肌"],
    "demoUrl": "/media/collections-20261008/demos/reviewed-e869e3bc497b15aa663326c0.mp4",
    "videoUrl": "/media/collections-20261008/videos/77b776dd8d1c617ce0d32c4d.mp4",
    "source": "焚诀计划 · 第9期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
